module.exports = "<c4ParamInput\n  *ngFor=\"let param of params; let i = index\"\n  [param]=\"param\"\n  (valueChange)=\"changeHandler($event, i)\">\n\n  </c4ParamInput>\n"


//////////////////
// WEBPACK FOOTER
// ./~/@c4/programming/src/app/common/params/param-inputs.component.html
// module id = 1534
// module chunks = 2